var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.88,
    height: 54.973,
    viewBox: "0 0 47.88 54.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-us",
    transform: "translate(-40 -8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(56.94 26.487)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(67.94 26.487)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_208",
    "data-name": "Trazado 208",
    d: "M80.609,47.076l-9.576-2.52V41.51a13.8,13.8,0,0,0,4.943-6.91H78.57a3.107,3.107,0,0,0,3.1-3.1V25.29a3.107,3.107,0,0,0-3.1-3.1H76.353V20.413a12.413,12.413,0,0,0-24.826,0v1.773H49.31a3.107,3.107,0,0,0-3.1,3.1V31.5a3.107,3.107,0,0,0,3.1,3.1h.443v3.547a.887.887,0,0,0,.887.887h3.647a15.8,15.8,0,0,0,2.559,2.477v3.046l-9.575,2.52A9.758,9.758,0,0,0,40,56.508v5.578a.887.887,0,0,0,.887.887H86.993a.887.887,0,0,0,.887-.887V56.508A9.759,9.759,0,0,0,80.609,47.076Zm-1.6-23.039A1.332,1.332,0,0,1,79.9,25.29V31.5a1.332,1.332,0,0,1-.887,1.252Zm-2.66-.078h.887v8.867h-.887ZM48.867,32.749A1.332,1.332,0,0,1,47.98,31.5V25.29a1.332,1.332,0,0,1,.887-1.252Zm23.758,14.06-3.687,7.009-3.583-1.756,5.1-5.825ZM63.94,50.986l-5.32-6.08V42.7a11.1,11.1,0,0,0,5.32,1.651A11.1,11.1,0,0,0,69.26,42.7v2.2ZM53.3,20.413a10.64,10.64,0,0,1,21.28,0V23.44A8.78,8.78,0,0,1,70,19.946a.888.888,0,0,0-1.193-.263A34.995,34.995,0,0,1,53.3,23.837ZM50.64,23.96h.887v8.867H50.64Zm.887,13.3V34.6H51.9a11.477,11.477,0,0,0,1.146,2.66Zm5.155,1.773h3.865a2.663,2.663,0,0,0,2.507,1.773h1.773a2.66,2.66,0,1,0,0-5.32H63.053a2.663,2.663,0,0,0-2.507,1.773h-5.4A9.166,9.166,0,0,1,53.3,31.94V25.61A36.847,36.847,0,0,0,69.014,21.6a10.415,10.415,0,0,0,5.566,3.685V31.94c0,1.524-.494,4.522-3.806,7.49-2.135,1.913-4.818,3.15-6.834,3.15s-4.7-1.237-6.834-3.15C56.958,39.3,56.818,39.165,56.681,39.033Zm5.485-.887a.888.888,0,0,1,.887-.887h1.773a.887.887,0,1,1,0,1.773H63.053a.888.888,0,0,1-.887-.887Zm-4.739,8.091,5.089,5.816L59,53.811l-3.692-7.017ZM60.587,61.2H47.98V57.653a.887.887,0,0,0-1.773,0V61.2H41.773V56.508a7.983,7.983,0,0,1,5.949-7.716l5.825-1.534,4.287,8.147a.888.888,0,0,0,1.181.381l.625-.314,1.585,3.17Zm1.829,0,.443-1.773h2.182l.5,1.773Zm2.75-3.547H62.714L61.228,54.68l2.691-1.346,2.735,1.339ZM86.106,61.2H81.673V57.653a.887.887,0,1,0-1.773,0V61.2H67.382l-.723-2.57,1.587-3.175.684.335a.874.874,0,0,0,.389.091.887.887,0,0,0,.786-.474l4.279-8.133,5.773,1.52a7.983,7.983,0,0,1,5.948,7.716Z",
    fill: "#e51b26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.2b63ae1d0740c80480db898d604c4d17.svg";
export { ForwardRef as ReactComponent };